class ReactivationFrequency extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.cart = document.querySelector('cart-drawer');
    this.backButton = this.querySelector('.back-button');

    this.#addEventListeners();
  }

  #addEventListeners() {
    this.backButton.addEventListener('click', () => {
      document.querySelector('.block_area_1').classList.remove('hidden');
      document.querySelector('.block_area_2').classList.add('hidden');
      window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 1 } }));
    });

    const showFrequencyButton = document.querySelector('.show_frequency_button');
    showFrequencyButton.addEventListener('click', () => {
      document.querySelector('.block_area_1').classList.add('hidden');
      document.querySelector('.block_area_2').classList.remove('hidden');
      window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 2 } }));
    });

    const sellingPlans = this.querySelectorAll('.selling_plan');
    sellingPlans.forEach((sellingPlan) => {
      sellingPlan.addEventListener('click', () => {
        this.variantId = sellingPlan.dataset.variantId;
        this.sellingPlanId = sellingPlan.dataset.sellingPlanId;
        this.selectedDiscount = sellingPlan.dataset.discountCode;
        this.giftDiscountCode = sellingPlan.dataset.giftDiscountCode;
        this.nextProductVariantId = sellingPlan.dataset.nextProductVariantId;
        this.secondProductVariantId = sellingPlan.dataset.secondProductOrProductVariantId;

        const frequencyRaw = sellingPlan.dataset.frequency;
        const frequencyProcessed = this.#processEventValue(frequencyRaw);

        this.#addToCart(sellingPlan);
        this.#fireEvents("frequency_selected", frequencyProcessed);
      });
    });
  }

  async #addToCart(element) {
    if (!element.dataset.sellingPlanId) {
      return;
    }

    element.setAttribute('disabled', 'disabled');
    element.classList.add('loading');
    element.querySelector('.loading__spinner').classList.remove('hidden');

    try {
      const signupConfig = {
        mainProduct: {
          variantId: this.variantId,
          sellingPlanId: this.sellingPlanId,
        },
        ...this.nextProductVariantId ? {nextProduct: {variantId: this.nextProductVariantId}} : {},
        ...this.secondProductVariantId ? {addonProduct: {variantId: this.secondProductVariantId}} : {},
        discountCode: this.selectedDiscount,
        ...this.giftDiscountCode ? {addonDiscountCode: this.giftDiscountCode} : {},
      };

      const subscriptionCart = new SubscriptionCart();
      await subscriptionCart.checkout(signupConfig, true);
    } catch (error) {
      console.log("Error while adding this product to cart: ", error);
    } finally {
      element.removeAttribute('disabled');
      element.classList.remove('loading');
      element.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));
      return cart;
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
    return null;
  }

  #fireEvents(eventAction, eventValue) {
    window.dataLayer.push({
      event: 'site_interaction',
      context: 'reactivation',
      action: eventAction,
      value: eventValue
    });
  }

  #processEventValue(value) {
    const numberValue = value.split(" ")[0];

    switch (Number(numberValue)) {
      case 1:
        return "monthly";
      case 2:
        return "bimonthly";
      case 3:
        return "quarterly";
      default:
        return `every ${value}`;
    }
  }
}

if (!customElements.get('reactivation-frequency')) {
  window.customElements.define('reactivation-frequency', ReactivationFrequency);
}
